import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Toolbar } from '@mui/material';
import { TextField, IconButton } from '@totalsoft/rocket-ui';
import Search from '@mui/icons-material/Search';
import Close from '@mui/icons-material/Close';

const AddFinancialProductToolbarComponent = ({ onFilterValueChanged, fullTextFilter, onResetFilters, disabledStatus }) => {
  const [t] = useTranslation();

  const onTextFilterChanged = useCallback(
    value => {
      onFilterValueChanged(value);
    },
    [onFilterValueChanged]
  );

  return (
    <Toolbar>
      <Grid item xs={12} sm={12}>
        <TextField
          id={'offerFinancingStructureCard_financialProductAddModal_filters_fulltext'}
          fullWidth={true}
          name='fullTextFilter'
          disabled={disabledStatus}
          value={fullTextFilter}
          onChange={onTextFilterChanged}
          placeholder={t('Placeholders.FinancialProductSearch')}
          startAdornment={<Search />}
          endAdornment={
            <IconButton
              onClick={onResetFilters}
              disabled={disabledStatus}
              variant='text'
              size='tiny'
              tooltip={t('Tooltips.ResetFilters')}
              id={'offerFinancingStructureCard_financialProductAddModal_filters_resetBtn'}
            >
              <Close />
            </IconButton>
          }
        />
      </Grid>
    </Toolbar>
  );
};

AddFinancialProductToolbarComponent.propTypes = {
  onFilterValueChanged: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  fullTextFilter: PropTypes.string.isRequired,
  disabledStatus: PropTypes.bool.isRequired
};

export default AddFinancialProductToolbarComponent;
